(function () {
  if (window.__svInit) return;
  window.__svInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sv-reveal:not(.sv-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-sv-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var strength = parseFloat(el.getAttribute('data-sv-parallax')) || 0;
        var rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * strength * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return value;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value;
    });
  }

  function addToCart(form, button) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function') return false;
    var fd = new FormData(form);
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    fd.append('sections_url', window.location.pathname);
    if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { window.location.href = '/cart'; return; }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        var bubble = document.querySelector('#cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var tmp = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (tmp) bubble.innerHTML = tmp.innerHTML;
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      });
    return true;
  }

  function initAjaxForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-sv-ajax]')) return;
      var button = form.querySelector('[type="submit"]');
      if (addToCart(form, button)) e.preventDefault();
    });
  }

  function initPdp() {
    document.querySelectorAll('[data-sv-pdp]').forEach(function (root) {
      if (root.__svReady) return;
      root.__svReady = true;

      var main = root.querySelector('[data-sv-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sv-thumb]'));
      var current = 0;
      function show(i) {
        if (!thumbs.length || !main) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.srcset = t.getAttribute('data-srcset') || '';
          main.alt = t.getAttribute('data-alt') || '';
          main.style.opacity = '1';
        }, 160);
        thumbs.forEach(function (x, n) { x.classList.toggle('is-active', n === current); });
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      var prev = root.querySelector('[data-sv-prev]');
      var next = root.querySelector('[data-sv-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      // Swipe on main image
      var startX = null;
      var mainWrap = root.querySelector('.sv-pdp__main');
      if (mainWrap) {
        mainWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }

      // Quantity
      var qty = root.querySelector('[data-sv-qty]');
      root.querySelectorAll('[data-sv-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-sv-step'), 10));
        });
      });

      // Variants
      var dataEl = root.querySelector('[data-sv-variants]');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-sv-price]');
      var compareEl = root.querySelector('[data-sv-compare]');
      var buttons = root.querySelectorAll('[data-sv-add]');
      var format = root.getAttribute('data-money-format');
      var soldOutText = root.getAttribute('data-sold-out');
      var addText = root.getAttribute('data-add');
      if (dataEl && idInput) {
        var variants = JSON.parse(dataEl.textContent);
        root.addEventListener('change', function (e) {
          if (!e.target.matches('[data-sv-option]')) return;
          var selected = [];
          root.querySelectorAll('[data-sv-option-group]').forEach(function (g) {
            var c = g.querySelector('input:checked');
            selected.push(c ? c.value : null);
          });
          var v = variants.find(function (x) {
            return x.options.every(function (o, i) { return o === selected[i]; });
          });
          if (!v) return;
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price, format);
          if (compareEl) {
            compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, format) : '';
          }
          buttons.forEach(function (b) {
            b.disabled = !v.available;
            var label = b.querySelector('[data-sv-label]');
            if (label) label.textContent = v.available ? addText : soldOutText;
          });
          if (v.featured_media) {
            var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_media.id; });
            if (idx > -1) show(idx);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      // Sticky add-to-cart bar
      var sticky = root.querySelector('[data-sv-sticky]');
      var anchor = root.querySelector('.sv-pdp__buy');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(anchor);
        var stickyBtn = sticky.querySelector('button');
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          var form = root.querySelector('form[data-sv-ajax]');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    });
  }

  function initAll() {
    initReveal();
    initPdp();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    initParallax();
    initAjaxForms();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initPdp();
  });
})();
